import { Flex } from 'antd';
import { spacing } from '../../theming';
import { labelStyle, valueStyle } from './vinExtractionStyles';

const CarInfoRow = ({ label, children }) => (
    <Flex justify="space-between" gap={spacing[2]}>
        <span style={labelStyle}>{label}</span>
        <span style={valueStyle}>{children}</span>
    </Flex>
);

export default CarInfoRow;
